import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from './plugins/vuetify';
import Header from "./components/elements/Header.vue";
import Sidemenu from "./components/elements/Sidemenu.vue";
import lodash from 'lodash'; 
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import VueMoment from "vue-moment";
import VueApexCharts from 'vue-apexcharts'
import Fragment from 'vue-fragment'
Vue.use(Fragment.Plugin)


Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)



Vue.component("page-header", Header);
Vue.component("side-menu", Sidemenu);

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title);
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  if (to.path == "/response") {
    // console.log("Response pagina");
    next();
  }
  else if (to.path == "/unsubscribe") {
    // console.log("Unsubscribe pagina");
    next();
  }
  
  else {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        // console.log("Firestore token aanwezig: ", to.path, to.query);
        store.dispatch("tryAutoLogin", user).then(() => {
       
          if(to.path == "/login" && to.query && to.query.d && to.query.d != 'login'){
            // console.log("login + query no login: ",  to.path, to.query)
            next('/'+ to.query.d);
          }
          else if (to.path == "/login" && to.query && to.query.d == 'login') {
            // console.log("login + query with login: ",  to.path, to.query)
            next("/dashboard");
          }
          else if (to.path == "/login") {
            // console.log("login")
            next("/dashboard");
          }
          else {
            // console.log("geen login")
            next();
          }
        });
      } else {
        console.log("Firestore token niet aanwezig");
        if (to.path == "/login") {
          next();
        } else {
          let path = window.location.pathname.substr(1);
          // console.log("Path: ", path)
          next("/login?d=" + path);
        }
      }
    });
  }
});

export const bus = new Vue();

Vue.use(require('vue-moment'));
Vue.prototype._ = lodash;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");


